"use strict";
import { createSlice } from "@reduxjs/toolkit";
export const initialUniswapBehaviorHistoryState = {
  hasViewedBridgingBanner: false,
  hasDismissedBridgingWarning: false,
  hasDismissedLowNetworkTokenWarning: false,
  hasViewedContractAddressExplainer: false,
  unichainPromotion: {
    coldBannerDismissed: false,
    warmBannerDismissed: false,
    networkSelectorAnimationSeen: false,
    networkSelectorTooltipSeen: false,
    bridgingTooltipSeen: false,
    bridgingAnimationSeen: false,
    isFirstUnichainBridgeSelection: true
  },
  hasShownMismatchToast: false
};
const slice = createSlice({
  name: "uniswapBehaviorHistory",
  initialState: initialUniswapBehaviorHistoryState,
  reducers: {
    setHasViewedBridgingBanner: (state, action) => {
      state.hasViewedBridgingBanner = action.payload;
    },
    setHasDismissedBridgingWarning: (state, action) => {
      state.hasDismissedBridgingWarning = action.payload;
    },
    setHasDismissedLowNetworkTokenWarning: (state, action) => {
      state.hasDismissedLowNetworkTokenWarning = action.payload;
    },
    setHasViewedContractAddressExplainer: (state, action) => {
      state.hasViewedContractAddressExplainer = action.payload;
    },
    setHasDismissedUnichainColdBanner: (state, action) => {
      state.unichainPromotion ??= {};
      state.unichainPromotion.coldBannerDismissed = action.payload;
    },
    setHasDismissedUnichainWarmBanner: (state, action) => {
      state.unichainPromotion ??= {};
      state.unichainPromotion.warmBannerDismissed = action.payload;
    },
    setHasSeenNetworkSelectorAnimation: (state, action) => {
      state.unichainPromotion ??= {};
      state.unichainPromotion.networkSelectorAnimationSeen = action.payload;
    },
    setHasSeenNetworkSelectorTooltip: (state, action) => {
      state.unichainPromotion ??= {};
      state.unichainPromotion.networkSelectorTooltipSeen = action.payload;
    },
    setHasSeenBridgingTooltip: (state, action) => {
      state.unichainPromotion ??= {};
      state.unichainPromotion.bridgingTooltipSeen = action.payload;
    },
    setIsFirstUnichainBridgeSelection: (state, action) => {
      state.unichainPromotion ??= {};
      state.unichainPromotion.isFirstUnichainBridgeSelection = action.payload;
    },
    setHasSeenBridgingAnimation: (state, action) => {
      state.unichainPromotion ??= {};
      state.unichainPromotion.bridgingAnimationSeen = action.payload;
    },
    // Should only be used for testing
    resetUniswapBehaviorHistory: (_state, _action) => {
      return initialUniswapBehaviorHistoryState;
    },
    setHasShownMismatchToast: (state, action) => {
      state.hasShownMismatchToast = action.payload;
    }
  }
});
export const {
  setHasViewedBridgingBanner,
  setHasDismissedBridgingWarning,
  setHasDismissedLowNetworkTokenWarning,
  setHasDismissedUnichainColdBanner,
  setHasDismissedUnichainWarmBanner,
  setHasSeenNetworkSelectorAnimation,
  setHasSeenNetworkSelectorTooltip,
  setHasSeenBridgingTooltip,
  setIsFirstUnichainBridgeSelection,
  setHasSeenBridgingAnimation,
  resetUniswapBehaviorHistory,
  setHasViewedContractAddressExplainer,
  setHasShownMismatchToast
} = slice.actions;
export const uniswapBehaviorHistoryReducer = slice.reducer;
